import get from 'lodash/get';

const otherImageUrl = '/dots.png';

export default (element, overwrite) => {
  const otherCaption = get(element, 'properties.otherValue');
  const elementId = element.id;
  const otherImageId = `other_${elementId}`;
  return {
    caption: otherCaption || 'Other',
    id: otherImageId,
    elementId,
    otherValue: JSON.stringify({ other: otherCaption || otherImageId }),
    large: { url: otherImageUrl },
    small: { url: otherImageUrl },
    original: { url: otherImageUrl },
    desktop: { url: otherImageUrl },
    ...overwrite,
  };
};
